export default __webpack_public_path__ + "static/media/curveNumberImage.203859ac.png";